import { requestV2 } from 'utils/axios';
import getToken from './getToken';

const ENDPOINT = 'shops';

export const edit = (shopId, data) => requestV2('put', `${ENDPOINT}/${shopId}`, getToken(), { data });

export const get = (shopId) =>
  requestV2('get', `${ENDPOINT}/${shopId}`);
